import { render, staticRenderFns } from "./quick-menu-fixed-bar.vue?vue&type=template&id=181f2cee&scoped=true"
import script from "./quick-menu-fixed-bar.vue?vue&type=script&lang=js"
export * from "./quick-menu-fixed-bar.vue?vue&type=script&lang=js"
import style0 from "./quick-menu-fixed-bar.vue?vue&type=style&index=0&id=181f2cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f2cee",
  null
  
)

export default component.exports